import { Toaster } from 'sonner@2.0.3';

export function ToastProvider() {
  return <Toaster position="top-right" richColors />;
}
